<template>
  <div id="Page404">
    <div class="logo">
      <router-link to="/">
        <img src="../assets/img/404/Group744.svg" style="height:4.1vh">
      </router-link>
    </div>
    <div class="errorcode404">
      <div class="error">Error code: 404</div>
    </div>
    <div class="oppsarea">
      <div class="oops">OOPS!</div>
    </div>
    <div class="text">
      <div class="we">
        We can't seem to find the page
        <br>you're looking for :(
      </div>
    </div>
    <div class="button">
      <router-link to="/" class="button1">Back to homepage</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: "Page404",
  components: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" spoed>
#Page404 {
  padding-top: 52px;
  .logo {
    position: absolute;
    top: 10%;
    right: 5%;
  }
  .errorcode404 {
    background-color: #e13036;
    width: 160px;
    height: 40px;
    border-radius: 5px 5px 5px 5px;
    margin-top: 50px;
    margin-left: 10px;
    .error {
      padding: 5px;
      font-size: 20px;
      color: white;
    }
  }
  .oppsarea {
    margin-left: 10px;
    margin-top: 10px;
    .oops {
      color: #e13036;
      font-size: 30px;
    }
  }
  .text {
    margin-left: 10px;
    margin-right: auto;
    margin-top: 10px;
    .we {
      color: #e13036;
      font-size: 20px;
    }
  }
  .button {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    .button1 {
      width: 100%;
      background-color: white;
      color: #e13036;
      border: 2px solid #e13036;
      padding: 7px 23px;
      text-align: center;
      text-decoration: none;
      display: inline-block;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>

